import React from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "../../components/Shell";
import { useAuth } from "../../lib/auth";
import { QrCode, FileText, User } from "lucide-react";

export default function MemberDashboard() {
  const { user } = useAuth();

  const tiles = [
    { to: "/member/qr", icon: <QrCode className="w-5 h-5" />, label: "My QR Code", accent: true },
    { to: "/member/documents", icon: <FileText className="w-5 h-5" />, label: "My Documents" },
    { to: "/member/profile", icon: <User className="w-5 h-5" />, label: "Profile" },
  ];

  return (
    <div data-testid="member-dashboard">
      <PageHeader eyebrow="Member" title={`Hi, ${user?.name?.split(" ")[0] || "Member"}`} />

      <div className="grid md:grid-cols-3 gap-0 border border-[#E4E4E7] bg-white">
        {tiles.map((t) => (
          <Link key={t.to} to={t.to}
            className={`p-6 border-r border-b md:border-b-0 border-[#E4E4E7] last:border-r-0 hover:bg-[#F7F7F8] transition-colors ${
              t.accent ? "bg-[#05126E] text-white hover:bg-[#030B45]" : ""
            }`}
            data-testid={`m-tile-${t.label.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className={`w-10 h-10 grid place-items-center mb-4 border-2 ${t.accent ? "border-white" : "border-[#0a0a0a]"}`}>
              {t.icon}
            </div>
            <div className="font-bold text-lg">{t.label}</div>
            <div className={`text-xs mt-1 ${t.accent ? "text-zinc-400" : "text-zinc-500"}`}>Open →</div>
          </Link>
        ))}
      </div>

      <div className="mt-8 border border-[#E4E4E7] bg-white p-6">
        <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#05126E]">
          How attendance works
        </div>
        <p className="mt-2 text-sm text-zinc-700 max-w-2xl">
          Show your QR code at any event organized by your organization. The
          Org Admin scans it; we automatically record your attendance — even
          if the venue has no internet.
        </p>
      </div>
    </div>
  );
}
